<script lang="ts">
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')
</script>

<div class="card">
	<div class="card-body">
		<h2 class="card-title text-center">
			{translate('common:noItemsForSelectedFilter', 'No items for selected filter')}
		</h2>
		<p class="card-text text-center">{translate('common:tryChangingYourFilter', 'Try changing your filter')}</p>
	</div>
</div>
